module.exports = __webpack_public_path__ + "static/media/Logo.ce0d6453.svg";